import LandingCardsPost, {
  LandingCardsPostProps
} from '../../../../components/_external-pages/landing/LandingCardsPost';

const props: LandingCardsPostProps = {
  title: 'Sala de prensa',
  cards: [
    {
      name: 'Así puede crecer tu PyMe al solicitar un crédito con iBAN Online',
      icon: '/static/artesano5.webp',
      to: 'https://www.tribuna.com.mx/politica/2021/11/16/asi-puede-crecer-tu-pyme-al-solicitar-un-credito-con-iban-online-275502.html',
      date: '16/11/2021',
      rate: 5,
      comment: 'Leer más'
    },
    {
      name: 'Conoce los beneficios de los créditos para PyMEs de iBAN Online',
      icon: '/static/artesano6.webp',
      to: 'https://www.informador.mx/economia/Conoce-los-beneficios-de-los-creditos-para-PyMEs-de-Iban-Online-20211027-0092.html',
      date: '27/10/2021',
      rate: 5,
      comment: 'Leer más'
    },
    {
      name: 'iBAN Online apuesta por el talento mexicano',
      icon: '/static/artesano7.webp',
      to: 'https://www.reforma.com/iban-online-apuesta-por-el-talento-mexicano/gr/ar2249404?md5=b36f5c7ea9282aca158a234a07193c35&ta=0dfdbac11765226904c16cb9ad1b2efe',
      date: '31/08/2021',
      rate: 5,
      comment: 'Leer más'
    }
  ]
};

export const HomeLandingCardPost = () => {
  return <LandingCardsPost {...props} />;
};
